/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import {
  ElSidebarComponent,
  ElSidebarFooterComponent,
  ElSidebarHeaderComponent,
} from './sidebar.component';

import { ElSidebarService } from './sidebar.service';

const EL_SIDEBAR_COMPONENTS = [
  ElSidebarComponent,
  ElSidebarFooterComponent,
  ElSidebarHeaderComponent,
];

const EL_SIDEBAR_PROVIDERS = [
  ElSidebarService,
];

@NgModule({
  imports: [
    ElSharedModule,
  ],
  declarations: [
    ...EL_SIDEBAR_COMPONENTS,
  ],
  exports: [
    ...EL_SIDEBAR_COMPONENTS,
  ],
})
export class ElSidebarModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ElSidebarModule,
      providers: [
        ...EL_SIDEBAR_PROVIDERS,
      ],
    };
  }
}
